import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
} from "react-icons/fa";
import logo from "../assets/logo.png";
import parceiro_germano from "../assets/Footer/parceiro_germano.jpg";
import protocolos_diet from "../assets/Footer/protocolos_diet.png";
import protocolos_ivi from "../assets/Footer/protocolos_ivi.jpg";
import protocolos_pronatural from "../assets/Footer/protocolos_pronatural.jpg";
import protocolos_LP from "../assets/Footer/protocolos_LP.png";
import protocolos_sams from "../assets/Footer/protocolos_sams.png";
import "../css/Footer.css";

const Footer = () => {
  return (
    <footer className="modern-footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Brand Section */}
            <div className="footer-brand">
              <img src={logo} alt="Life Center" className="footer-logo" />
              <p className="footer-tagline">
                O seu centro de excelência em saúde, exercício e bem-estar.
              </p>
              <div className="footer-social">
                <a
                  href="https://www.facebook.com/lifecenterlisboa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.instagram.com/o2lifecenter/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://wa.me/+351962281179"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn whatsapp"
                >
                  <FaWhatsapp />
                </a>
              </div>
            </div>

            {/* Contact Info */}
            <div className="footer-contact">
              <h4>Contactos</h4>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <p>Avenida de Pádua nº 10 L</p>
                  <p>1800-297 Lisboa</p>
                </div>
              </div>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div>
                  <p>
                    <a href="tel:+351218531900">218 531 900</a>
                  </p>
                  <p>
                    <a href="tel:+351962281179">962 281 179</a>
                  </p>
                </div>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <p>
                  <a href="mailto:info@o2-lifecenter.com">
                    info@o2-lifecenter.com
                  </a>
                </p>
              </div>
              <div className="contact-item">
                <FaClock className="contact-icon" />
                <div>
                  <p>Seg - Sex: 7h - 21h</p>
                  <p>Sábado: 9h - 14h</p>
                </div>
              </div>
            </div>

            {/* Protocolos */}
            <div className="footer-protocols">
              <h4>Protocolos</h4>
              <div className="protocols-grid">
                <img src={protocolos_diet} alt="Diet Import" />
                <img src={protocolos_LP} alt="LPAA" />
                <img src={protocolos_ivi} alt="IVI" />
                <img src={protocolos_sams} alt="Sams Quadros" />
                <img src={protocolos_pronatural} alt="Pronatural" />
              </div>
            </div>

            {/* Parceiros */}
            <div className="footer-partners">
              <h4>Parceiros</h4>
              <div className="partners-grid">
                <img src={parceiro_germano} alt="Germano De Sousa" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <p>
            © {new Date().getFullYear()} Life Center. Todos os direitos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
